exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cm-s-ambiance.CodeMirror{box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/codemirror/theme/ambiance-mobile.css
// module id = 343
// module chunks = 0